import * as React from "react";

import { FormForgotPassword } from "../form-forgot-password";

export const PageDetails: React.FunctionComponent = () => {
  return (
    <div className="page page-details">
      <div className="header">
        <h2>{`Enter your email address.`}</h2>
        <h5>{`You will receive a link in your email to reset your password.`}</h5>
      </div>

      <FormForgotPassword />

      <a className="back-to-sign-in-link" href="/customer/account/login">
        <span>{`Back to sign in`}</span>
      </a>
    </div>
  );
};
